import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipodenovedadesComponent } from './components/tipodenovedades/tipodenovedades.component';

const routes: Routes = [
  { path: 'tipodenovedades', component: TipodenovedadesComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipodenovedadesRoutingModule { }
